import * as React from 'react';
import {createPortal} from 'react-dom';
import {Z_INDEXES} from '@packages/utilities/styled';

type Cursor =
  | 'alias'
  | 'all-scroll'
  | 'auto'
  | 'cell'
  | 'context-menu'
  | 'col-resize'
  | 'copy'
  | 'crosshair'
  | 'default'
  | 'e-resize'
  | 'ew-resize'
  | 'grab'
  | 'grabbing'
  | 'help'
  | 'move'
  | 'n-resize'
  | 'ne-resize'
  | 'nesw-resize'
  | 'ns-resize'
  | 'nw-resize'
  | 'nwse-resize'
  | 'no-drop'
  | 'none'
  | 'not-allowed'
  | 'pointer'
  | 'progress'
  | 'row-resize'
  | 's-resize'
  | 'se-resize'
  | 'sw-resize'
  | 'text'
  | 'w-resize'
  | 'wait'
  | 'zoom-in'
  | 'zoom-out';

export class DragGhost extends React.PureComponent<{
  dragging: boolean;
  cursor?: Cursor;
  children?: React.ReactNode;
}> {
  render() {
    const {dragging, cursor, children} = this.props;

    if (!dragging) {
      return null;
    }

    const dragGhostEl = window.document.getElementById('drag-ghost');

    return dragGhostEl
      ? createPortal(
          <div
            style={{
              cursor,
              zIndex: Z_INDEXES.zIndexFullPageMask,
              width: '100vw',
              height: '100vh',
              position: 'fixed',
              left: 0,
              top: 0,
            }}
          >
            {children}
          </div>,
          dragGhostEl
        )
      : null;
  }
}

export default DragGhost;
